<ng-container *ngFor="let infoLine of infoLines; let i = index">
    <div class="box-status-video status-video-{{i + 1}}">
        <span  class="status-video {{infoLine.cssClass}}" *ngIf="infoLine" (click)="infoLine?.action()">
            <i *ngIf="infoLine.cssIconClass" class="icon icon-{{infoLine.cssIconClass}}"></i> {{ infoLine.text | localize }}
        </span>
    </div>
</ng-container>
